import moment from "moment";
import { branding, Colour_Tournament } from "./Utils";

export class CBManual {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "CBMANUAL";
    this.scene = "CBMANUAL";
    this.data = [];
    this.page = 7050;
  }

  async preview({ options }) {
    this.onAir = false;

    this.page = 7050;
    if (options?.box?.graphic_type === "form") {
      this.page = 7061;
    } else if (options?.box?.graphic_type === "fixtures") {
      this.page = 7060;
    }
    let xml = await this.getVizPage({ page: this.page }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml = Colour_Tournament({ game: options.game, xml });

      if (options.box?.graphic_type === "form") {
        xml = this.form({ xml, options });
      } else if (options.box?.graphic_type === "fixtures") {
        xml = this.fixtures({ xml, options });
      } else {
        xml = this.generic({ xml, options });
      }
      await this.updateVizPage({ page: this.page, data: xml }).catch((err) => {
        console.log(err);
      });

      await this.sendPreview("page:read " + this.page);
    }
  }
  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }

  generic({ xml, options }) {
    try {
      xml.payload.field.find((item) => {
        return item.attr.name === "0000";
      }).value = "0";
    } catch (err) {}
    // }
    let period = [...(options?.game?.live_data?.periods || [])].sort(
      (a, b) => b.number - a.number,
    )[0];

    if (period.number === 1 && period.kick_off === null) {
      try {
        xml.payload.field.find((item) => {
          return item.attr.name === "0001";
        }).value = "1";
      } catch (err) {}
    } else {
      try {
        xml.payload.field.find((item) => {
          return item.attr.name === "0001";
        }).value = "2";
      } catch (err) {}
    }

    if (
      period.kick_off === null ||
      !options?.box?.colour_type ||
      options?.box?.colour_type === "SL Generic"
    ) {
      xml.payload.field.find((item) => {
        return item.attr.name === "0002";
      }).value = "0";
      xml.payload.field.find((item) => {
        return item.attr.name === "000501";
      }).value = "0";
    } else {
      xml = branding({
        game: options.game,
        xml,
        team:
          options?.box?.colour_type === "home"
            ? options?.game?.home_team
            : options?.box?.colour_type === "away"
              ? options?.game?.away_team
              : "",
      });
    }

    xml.payload.field.find((item) => {
      return item.attr.name === "0007";
    }).value = options?.box?.number_columns;

    xml.payload.field.find((item) => {
      return item.attr.name === "0004";
    }).value = options?.box?.number_rows;

    let folder = "";
    if (options?.box?.title_badge_folder === "team") {
      folder = "IMAGE*___MEDIA/RUGBY_LEAGUE/TEAM_BADGES/";
    } else if (options?.box?.title_badge_folder === "competition") {
      folder = "IMAGE*___MEDIA/RUGBY_LEAGUE/COMPETITION_LOGOS/";
    }
    xml.payload.field.find((item) => {
      return item.attr.name === "0000102";
    }).value = folder + (options?.box?.title_badge ?? "");
    xml.payload.field.find((item) => {
      return item.attr.name === "0000102";
    }).value = folder + (options?.box?.title_badge ?? "");
    xml.payload.field.find((item) => {
      return item.attr.name === "0005";
    }).value = options?.box?.show_badges ? "1" : "0";
    let lines = options?.box?.heading?.split("\n");

    xml.payload.field.find((item) => {
      return item.attr.name === "0000103";
    }).value = lines?.length > 1 ? lines?.[0] : "";
    xml.payload.field.find((item) => {
      return item.attr.name === "0000104";
    }).value = lines?.length > 1 ? lines?.[1] : lines?.[0];
    xml.payload.field.find((item) => {
      return item.attr.name === "0000106";
    }).value = options?.box?.subtitle;

    xml.payload.field.find((item) => {
      return item.attr.name === "00300";
    }).value = options?.box?.number_columns >= 1 ? options?.box?.column_1 :'';

    xml.payload.field.find((item) => {
      return item.attr.name === "00400";
    }).value = options?.box?.number_columns >= 2 ? options?.box?.column_2 :'';

    xml.payload.field.find((item) => {
      return item.attr.name === "00500";
    }).value = options?.box?.number_columns >= 3 ? options?.box?.column_3 : '';

    xml.payload.field.find((item) => {
      return item.attr.name === "00600";
    }).value = options?.box?.number_columns >= 4 ? options?.box?.column_4 : '';

    let TEXT_1_HAS_VALUE = false;
    for (let r = 0; r < options?.box?.number_rows; r++) {
      xml.payload.field.find((item) => {
        return item.attr.name === "0" + (r + 1) + "0";
      }).value = options?.box?.rows?.[r]?.highlighted ? "2" : "1";
      //NOT AVAILABLE IN NEW CB
      // xml.payload.field.find((item) => {
      //   return item.attr.name === "0" + (r + 1) + "9";
      // }).value = options?.box?.rows?.[r]?.dots ? "1" : "0";
      if (
        options?.box?.rows?.[r]?.number &&
        options?.box?.rows?.[r]?.number !== ""
      ) {
        TEXT_1_HAS_VALUE = true;
      }
      
      xml.payload.field.find((item) => {
        return item.attr.name === "0" + (r + 1) + "01";
      }).value = options?.box?.rows?.[r]?.number ?? "";
      xml.payload.field.find((item) => {
        return item.attr.name === "0" + (r + 1) + "02";
      }).value = options?.box?.rows?.[r]?.text ?? "";
      xml.payload.field.find((item) => {
        return item.attr.name === "0" + (r + 1) + "021";
      }).value = options?.box?.rows?.[r]?.small_text ?? "";
      xml.payload.field.find((item) => {
        return item.attr.name === "0" + (r + 1) + "03";
      }).value =(options?.box?.number_columns >= 1 && options?.box?.rows?.[r]?.col_1text) ?? "";
      xml.payload.field.find((item) => {
        return item.attr.name === "0" + (r + 1) + "04";
      }).value = (options?.box?.number_columns >= 2 && options?.box?.rows?.[r]?.col_2text) ?? "";
      xml.payload.field.find((item) => {
        return item.attr.name === "0" + (r + 1) + "05";
      }).value = (options?.box?.number_columns >= 3 && options?.box?.rows?.[r]?.col_3text) ?? "";
      xml.payload.field.find((item) => {
        return item.attr.name === "0" + (r + 1) + "06";
      }).value = (options?.box?.number_columns >= 4 && options?.box?.rows?.[r]?.col_4text) ?? "";
      xml.payload.field.find((item) => {
        return item.attr.name === "0" + (r + 1) + "101";
      }).value = options?.box?.rows?.[r]?.badge ?? "";
    }
    xml.payload.field.find((item) => {
      return item.attr.name === "0006";
    }).value = TEXT_1_HAS_VALUE ? "0" : "1";
    return xml;
  }
  form({ xml, options }) {
    try {
      xml.payload.field.find((item) => {
        return item.attr.name === "0000";
      }).value = "0";
    } catch (err) {}
    // }
    let period = [...(options?.game?.live_data?.periods || [])].sort(
      (a, b) => b.number - a.number,
    )[0];

    if (period.number === 1 && period.kick_off === null) {
      try {
        xml.payload.field.find((item) => {
          return item.attr.name === "0001";
        }).value = "1";
      } catch (err) {}
    } else {
      try {
        xml.payload.field.find((item) => {
          return item.attr.name === "0001";
        }).value = "2";
      } catch (err) {}
    }

    if (
      period.kick_off === null ||
      !options?.box?.colour_type ||
      options?.box?.colour_type === "SL Generic"
    ) {
      xml.payload.field.find((item) => {
        return item.attr.name === "0002";
      }).value = "0";
      xml.payload.field.find((item) => {
        return item.attr.name === "000501";
      }).value = "0";
    } else {
      xml = branding({
        game: options.game,
        xml,
        team:
          options?.box?.colour_type === "home"
            ? options?.game?.home_team
            : options?.box?.colour_type === "away"
              ? options?.game?.away_team
              : "",
      });
    }

    xml.payload.field.find((item) => {
      return item.attr.name === "0004";
    }).value = options?.box?.number_rows;

    xml.payload.field.find((item) => {
      return item.attr.name === "000053.active";
    }).value = options?.box?.number_columns >= 1 ? 1 : 0;
    xml.payload.field.find((item) => {
      return item.attr.name === "000054.active";
    }).value = options?.box?.number_columns >= 2 ? 1 : 0;
    xml.payload.field.find((item) => {
      return item.attr.name === "000055.active";
    }).value = options?.box?.number_columns >= 3 ? 1 : 0;
    xml.payload.field.find((item) => {
      return item.attr.name === "000056.active";
    }).value = options?.box?.number_columns >= 4 ? 1 : 0;

    let folder = "";
    if (options?.box?.title_badge_folder === "team") {
      folder = "IMAGE*___MEDIA/RUGBY_LEAGUE/TEAM_BADGES/";
    } else if (options?.box?.title_badge_folder === "competition") {
      folder = "IMAGE*___MEDIA/RUGBY_LEAGUE/COMPETITION_LOGOS/";
    }
    xml.payload.field.find((item) => {
      return item.attr.name === "0000102";
    }).value = folder + (options?.box?.title_badge ?? "");
    xml.payload.field.find((item) => {
      return item.attr.name === "0000102";
    }).value = folder + (options?.box?.title_badge ?? "");
    xml.payload.field.find((item) => {
      return item.attr.name === "0005";
    }).value = options?.box?.show_badges ? "1" : "0";
    let lines = options?.box?.heading?.split("\n");

    xml.payload.field.find((item) => {
      return item.attr.name === "0000103";
    }).value = lines?.length > 1 ? lines?.[0] : "";
    xml.payload.field.find((item) => {
      return item.attr.name === "0000104";
    }).value = lines?.length > 1 ? lines?.[1] : lines?.[0];
    xml.payload.field.find((item) => {
      return item.attr.name === "0000106";
    }).value = options?.box?.subtitle;

    for (let r = 0; r < options?.box?.number_rows; r++) {
      xml.payload.field.find((item) => {
        return item.attr.name === "0" + (r + 1) + "0";
      }).value = options?.box?.rows?.[r]?.highlighted ? "2" : "1";

      xml.payload.field.find((item) => {
        return item.attr.name === "0" + (r + 1) + "01";
      }).value = options?.box?.rows?.[r]?.number ?? "";
      xml.payload.field.find((item) => {
        return item.attr.name === "0" + (r + 1) + "02";
      }).value = options?.box?.rows?.[r]?.text ?? "";

      xml.payload.field.find((item) => {
        return item.attr.name === "0" + (r + 1) + "03";
      }).value = options?.box?.rows?.[r]?.col_1text ?? "";
      xml.payload.field.find((item) => {
        return item.attr.name === "0" + (r + 1) + "04";
      }).value = options?.box?.rows?.[r]?.col_2text ?? "";
      xml.payload.field.find((item) => {
        return item.attr.name === "0" + (r + 1) + "05";
      }).value = options?.box?.rows?.[r]?.col_3text ?? "";
      xml.payload.field.find((item) => {
        return item.attr.name === "0" + (r + 1) + "06";
      }).value = options?.box?.rows?.[r]?.col_4text ?? "";
      xml.payload.field.find((item) => {
        return item.attr.name === "0" + (r + 1) + "101";
      }).value = options?.box?.rows?.[r]?.badge ?? "";
    }

    return xml;
  }
  fixtures({ xml, options }) {
    try {
      xml.payload.field.find((item) => {
        return item.attr.name === "0000";
      }).value = "0";
    } catch (err) {}
    // }
    let period = [...(options?.game?.live_data?.periods || [])].sort(
      (a, b) => b.number - a.number,
    )[0];

    if (period.number === 1 && period.kick_off === null) {
      try {
        xml.payload.field.find((item) => {
          return item.attr.name === "0001";
        }).value = "1";
      } catch (err) {}
    } else {
      try {
        xml.payload.field.find((item) => {
          return item.attr.name === "0001";
        }).value = "2";
      } catch (err) {}
    }

    xml.payload.field.find((item) => {
      return item.attr.name === "0004";
    }).value = options?.box?.number_rows;

    let folder = "";
    if (options?.box?.title_badge_folder === "team") {
      folder = "IMAGE*___MEDIA/RUGBY_LEAGUE/TEAM_BADGES/";
    } else if (options?.box?.title_badge_folder === "competition") {
      folder = "IMAGE*___MEDIA/RUGBY_LEAGUE/COMPETITION_LOGOS/";
    }
    xml.payload.field.find((item) => {
      return item.attr.name === "001";
    }).value = folder + (options?.box?.title_badge ?? "");

    xml.payload.field.find((item) => {
      return item.attr.name === "002";
    }).value = options?.box?.heading ?? "";

    xml.payload.field.find((item) => {
      return item.attr.name === "005";
    }).value = options?.box?.subtitle;
    debugger;
    xml.payload.field.find((item) => {
      return item.attr.name === "0007";
    }).value = options?.box?.number_columns >= 1 ? "1" : "0";

    for (let r = 0; r < options?.box?.number_rows; r++) {
      xml.payload.field.find((item) => {
        return item.attr.name === "0" + (r + 1) + "0";
      }).value = options?.box?.rows?.[r]?.highlighted ? "2" : "1";

      xml.payload.field.find((item) => {
        return item.attr.name === "0" + (r + 1) + "01";
      }).value = options?.box?.rows?.[r]?.text;

      xml.payload.field.find((item) => {
        return item.attr.name === "0" + (r + 1) + "02";
      }).value = options?.box?.rows?.[r]?.number;

      xml.payload.field.find((item) => {
        return item.attr.name === "0" + (r + 1) + "03";
      }).value = options?.box?.rows?.[r]?.text_2;

      xml.payload.field.find((item) => {
        return item.attr.name === "0" + (r + 1) + "04";
      }).value = options?.box?.rows?.[r]?.col_1text;
    }

    return xml;
  }
}
